export default {
    "driverStatusDelete_title": "Delete Driver States",
    "driverStatusDelete_deleteWarning": "Are you sure you want delete the following driver states? This action can't be undone",
    "driverStatusDelete_success": "Success",
    "driverStatusDelete_successMessage": "Driver states deleted successfully",
}